import { basicInfo } from './modules/basicInfo'
import { inspector } from './modules/inspector'
// import { parkingAnalysis } from './modules/parkingAnalysis'
import { parkingManagement } from './modules/parkingManagement'
import { parkingRecord } from './modules/parkingRecord'
import { payConfigure } from './modules/payConfigure'
import { roadsideAnalysis } from './modules/roadsideAnalysis'
// import { roadsideRecord } from './modules/roadsideRecord'
import { roadsideManagement } from './modules/roadsideManagement'
import { vehicle } from './modules/vehicle'
import {guidanceScreenSystem} from "./modules/guidanceScreenSystem"

const OperationLayOut = () => import(/*webpackChunkName:'operation'*/'@/page/operation/operationLayOut.vue')

export const operation={
    path:'/operation',
    name: '运营中心',
    component: OperationLayOut,
    redirect:'/main/businessManagement/group',
    children:[
        basicInfo,
        inspector,
        // parkingAnalysis,
        parkingManagement,
        parkingRecord,
        payConfigure,
        roadsideAnalysis,
        // roadsideRecord,
        roadsideManagement,
        vehicle,
        guidanceScreenSystem
        ]
}